import { Component, Input } from '@angular/core';
import { GridLayoutItemComponent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'BI-grid-layout-item',
  templateUrl: './bi-grid-layout-item.component.html',
  styleUrls: ['./bi-grid-layout-item.component.scss']
})
export class BIGridLayoutItemComponent extends GridLayoutItemComponent {
/*  @Input() row!: number;
  @Input() col!: number;
  @Input() colSpan!: number;
  @Input() rowSpan!: number;
  constructor() {}*/
  
}
